export class PlaceholderPipe {

    private type: string;
    private params: string | undefined;

    private constructor(
        type: string,
        params: string | undefined
    ) {
        this.type = type;
        this.params = params;
    }

    public static create(type: string, params?: string): PlaceholderPipe {
        return new PlaceholderPipe(type, params);
    }

    public getType(): string {
        return this.type;
    }

    public setType(type: string): void {
        this.type = type;
    }

    public getParams(): string | undefined {
        return this.params;
    }

    public setParams(params: string | undefined): void {
        this.params = params;
    }

}

export namespace PlaceholderPipe {
    export enum Type {
        DATE = 'date',
        LOCAL_DATE = 'local-date',
        NUMBER = 'number'
    }
}